import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { useNavigate } from "react-router-dom";
import { AddBtn } from "components/common/button";
import { TableSearchInput } from "components/common/input";
import { PrimayPagination } from "components/common/pagination";
import { FoldingScreenListTable } from "components/foldingScreen";
import type { IFoldingScreen } from "service/interface/digital";
import routerConstant from "service/constant/routerConstant";

export function FoldingScreenListPage() {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectPage, setSelectPage] = useState<number>(1);
  const [listData, setListData] = useState<{
    count: number;
    data: IFoldingScreen[];
  }>({ count: 0, data: [] });

  const { data, mutate } = useSWR(
    `/admin/manage/foldingscreen?limit=12&offset=${
      selectPage * 12 - 12
    }&search=${searchValue}`,
  );

  useEffect(() => {
    if (data) {
      setListData(data);
    }
  }, [data]);

  const handleAddBtn = () => {
    navigate(`${routerConstant.FOLDINGSCREEN.index}/add`);
  };

  return (
    <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
      <div className="mx-auto w-[1167px] p-[78px_80px_55px_64px]">
        <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
          메모리올 관리자 화면
        </p>
        <p className="m-0 text-[32px] font-medium leading-[40px] text-gray-4">
          디지털 추모 <span className="text-black">/ 병풍</span>
        </p>
        <div className="mb-[24px] mt-[16px] flex items-center justify-between">
          <TableSearchInput
            value={searchValue}
            setValue={setSearchValue}
            placeholder="제목을 검색해보세요"
          />
          <AddBtn onClick={handleAddBtn} />
        </div>
        <FoldingScreenListTable data={listData.data} mutate={mutate} />
        <div className="mt-[32px] flex justify-end">
          <PrimayPagination
            listLength={Math.ceil(listData.count / 12)}
            pageNumber={selectPage}
            setPageNumber={setSelectPage}
          />
        </div>
      </div>
    </div>
  );
}
